import React from "react";
import { Link } from "react-router-dom";

const Author = ({ authorImage, author, author_linkdin, linkdin_followers }) => {
  return (
    <div className="mx-auto flex w-full flex-col items-center gap-8 rounded-3xl bg-white/50 p-8 shadow-2xl backdrop-blur-xl ring-1 ring-black/5 dark:bg-[#1a1f2e]/80 dark:ring-white/10 sm:flex-row sm:gap-10 sm:p-10">
      <div className="relative group">
        <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-violet-600 via-primary to-secondary opacity-75 blur transition duration-500 group-hover:opacity-100"></div>
        <img
          className="relative h-24 w-24 rounded-full object-cover ring-4 ring-white dark:ring-[#1a1f2e] sm:h-32 sm:w-32 transition-transform duration-500 group-hover:scale-105"
          src={
            author_linkdin && author_linkdin.includes("linkedin.com")
              ? `https://ui-avatars.com/api/?name=${encodeURIComponent(author)}&background=random` // Fallback since we can't easily fetch LinkedIn profile image without an API
              : typeof authorImage === 'string' && authorImage && !authorImage.includes("via.placeholder.com") && !authorImage.includes("C:\\") && !authorImage.includes("C:/")
                ? authorImage
                : "https://ui-avatars.com/api/?name=" + encodeURIComponent(author)
          }
          alt={`Author ${author}`}
        />
        <div className="absolute bottom-1 right-1 h-6 w-6 rounded-full bg-green-500 ring-4 ring-white dark:ring-[#1a1f2e]"></div>
      </div>

      <div className="flex flex-1 flex-col items-center text-center sm:items-start sm:text-left">
        <div className="mb-2 flex items-center gap-2">
          <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-primary dark:bg-primary/20 dark:text-primary-foreground">
            Author
          </span>
        </div>
        <h2 className="text-3xl font-bold capitalize text-gray-900 dark:text-white sm:text-4xl">
          {author}
        </h2>
        <p className="mt-2 max-w-lg text-gray-500 dark:text-gray-400">
          Passionate writer and developer sharing insights on technology, design, and innovation.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-4 sm:justify-start">
          <div className="flex items-center gap-2 rounded-xl bg-gray-100 px-4 py-2 dark:bg-white/5">
            <span className="text-lg font-bold text-gray-900 dark:text-white">
              {linkdin_followers > 500 ? "500+" : linkdin_followers}
            </span>
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Followers</span>
          </div>

          <Link
            to={author_linkdin}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 px-6 py-2.5 font-semibold text-white shadow-lg shadow-blue-500/30 transition-all hover:scale-105 hover:shadow-blue-500/50 active:scale-95"
          >
            <span>Connect on LinkedIn</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="h-4 w-4 transition-transform group-hover:translate-x-1"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Author;
